'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCarousel = require('../../src/styles/widget-carousel.scss');

var _widgetCarousel2 = _interopRequireDefault(_widgetCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Arrow() {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '30', viewBox: '0 0 20 30' },
        _react2.default.createElement('polygon', { points: '20 15 4.228 0 0 3.626 11.954 15 0 26.374 4.228 30' })
    );
}

var WidgetCarousel = function (_React$Component) {
    (0, _inherits3.default)(WidgetCarousel, _React$Component);

    function WidgetCarousel(props) {
        (0, _classCallCheck3.default)(this, WidgetCarousel);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

        _this.state = { visible: true };
        return _this;
    }

    WidgetCarousel.prototype.animate = function animate(callback) {
        var _this2 = this;

        this.setState({ visible: false });
        setTimeout(function () {
            var t = callback();
            if (typeof t.then === 'function') {
                t.then(function () {
                    _this2.setState({ visible: true });
                });
            } else {
                setTimeout(function () {
                    _this2.setState({ visible: true });
                }, 300);
            }
        }, 500);
    };

    WidgetCarousel.prototype.render = function render() {
        var _this3 = this;

        var content = this.props.slides;
        var styles = this.props.classNames ? (0, _extends3.default)({}, _widgetCarousel2.default, this.props.classNames) : _widgetCarousel2.default;
        var wrapperClasses = styles['wc__slide-wrapper'] + ' ' + (this.state.visible ? styles['wc__slide-wrapper--visible'] : '');

        return _react2.default.createElement(
            'div',
            { className: styles.wc },
            _react2.default.createElement(
                'div',
                { className: styles['wc__arrow'] + ' ' + styles['wc__arrow--left'], onClick: function onClick() {
                        return _this3.animate(_this3.props.prevSlide);
                    } },
                _react2.default.createElement(Arrow, null)
            ),
            _react2.default.createElement(
                'div',
                { className: styles['wc__content'] },
                _react2.default.createElement(
                    'div',
                    { className: wrapperClasses },
                    content
                )
            ),
            _react2.default.createElement(
                'div',
                { className: styles['wc__arrow'] + ' ' + styles['wc__arrow--right'], onClick: function onClick() {
                        return _this3.animate(_this3.props.nextSlide);
                    } },
                _react2.default.createElement(Arrow, null)
            )
        );
    };

    return WidgetCarousel;
}(_react2.default.Component);

;

WidgetCarousel.defaultProps = {
    slides: {},
    nextSlide: function nextSlide() {},
    prevSlide: function prevSlide() {}
};

exports.default = WidgetCarousel;